<template>

</template>

<script>
export default {
  name: "connect"
}
</script>

<style scoped>

</style>
